import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { RETRY_ALLOWED } from 'src/app/core/interceptors/http-error.interceptor';
import { environment } from 'src/environments/environment';

import { Employer, EmployerCorrectionRequest, EmployerCorrectionResult, EmployerListResponseDto } from '../models/employer-correction.model';

@Injectable({ providedIn: 'root' })
export class EmployerService {
  UpdateEmployer_apiURL = `${environment.apiUrl}/loan/api/admin`;
  employer_apiURL = `${environment.apiUrl}/loan/api/branch`;
  correction_apiURL = `${environment.apiUrl}/loan/api/admin`;

  HttpParamsOptions = {
      headers: new HttpHeaders({
        "content-type": "application/json"
      }),
      context: new HttpContext().set(RETRY_ALLOWED, true)
    };

  constructor(private http: HttpClient) { }

  /** Fetch all employers from the backend. */
  getEmployers(): Observable<EmployerListResponseDto> {
    return this.http.get<EmployerListResponseDto>(`${this.employer_apiURL}/getAllBranches`);
  }

  /** Persist a corrected employer name. */
  findEmployerBySerial(serial: string): Observable<Employer[]> {
    return this.http.post<Employer[]>(`${this.UpdateEmployer_apiURL}/findEmployersBySerial`, { branchSerial: serial },this.HttpParamsOptions);
  }

  findEmployersByName(name: string): Observable<Employer[]> {
    return this.http.post<Employer[]>(`${this.UpdateEmployer_apiURL}/findEmployersByName`, { employerName: name }, this.HttpParamsOptions);
  }

  /** Persist a corrected employer name. */
  updateEmployerName( name: string, tnr: number, serial: string, correctedName: string): Observable<Employer> {
    const body = { employerName: name, branchSerial: serial, employerTNR: tnr, correctedName: correctedName  };
    return this.http.post<Employer>(`${this.UpdateEmployer_apiURL}/employerCorrect`, body,this.HttpParamsOptions);
  }

  /** Apply a single employer name correction (DB + 3rd-party vendor). */
  correctEmployer(payload: EmployerCorrectionRequest): Observable<EmployerCorrectionResult> {
    return this.http.post<EmployerCorrectionResult>(`${this.correction_apiURL}/correctEmployer`, payload, this.HttpParamsOptions);
  }

  /** Apply a batch of employer name corrections (DB + 3rd-party vendor). */
  correctEmployers(payload: EmployerCorrectionRequest[]): Observable<EmployerCorrectionResult[]> {
    return this.http.post<EmployerCorrectionResult[]>(`${this.correction_apiURL}/correctEmployers`, payload, this.HttpParamsOptions);
  }
}
